import { styled } from '@mui/system'
import { Avatar } from '@mui/material'

export const Container = styled('div')(({ theme, background }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '30px',
  width: '100%', // Changed from calc(100% - 40px) to 100%
  maxWidth: '100%', // Ensure it doesn't overflow
  boxSizing: 'border-box', // Include padding in width calculation
  margin: '20px 0', // Changed from auto to 0 horizontal margins
  position: 'relative',
  backgroundColor: theme.palette.primary.main,
  backgroundImage: background ? `url(${background})` : 'none',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '12px',
  color: '#fff',
  overflow: 'hidden', // Ensures content doesn't overflow border radius
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 0,
  },
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
}))

export const ContentWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '24px', // Increased spacing between avatar and text
})

export const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  '& .subtitle': {
    fontSize: '16px',
    color: 'rgba(255, 255, 255, 0.85)',
    marginTop: '4px'
  }
})

export const StyledAvatar = styled(Avatar)({
  width: '80px', // Increased avatar size to better match the banner
  height: '80px',
  border: '3px solid white',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
})

export const UserName = styled('div')({
  fontSize: '28px',
  fontWeight: '600',
  color: '#fff',
  textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
})